// extracted by mini-css-extract-plugin
module.exports = {"title":"src-components-Tickets-Kefus-KefuDetails-KefuDetails-module__title--2BlTD"};